import { Card, CardContent, Skeleton, Typography } from '@mui/material';
import { ProductBase, ProductStatus } from 'generated/graphql';

interface Props {
  isLoading: boolean;
  products?: ProductBase[];
}

export const ProductActiveStatsCard: React.FC<Props> = ({ isLoading, products }) => {
  const activeProducts = products?.filter((product) => product.status == ProductStatus.Active);
  const activeProductsLastWeek = activeProducts?.filter((product) => {
    const creationTimestamp = product.creationTimestamp;
    const lastWeekTimestamp = new Date();
    lastWeekTimestamp.setDate(lastWeekTimestamp.getDate() - 7);
    return creationTimestamp && creationTimestamp >= lastWeekTimestamp;
  });
  return isLoading ? (
    <Skeleton height={96} variant="rectangular" />
  ) : (
    <Card>
      <CardContent>
        <Typography component="div" variant="h5">{`${activeProducts?.length} aktívnych produktov`}</Typography>
        <Typography color="text.secondary">{`+${activeProductsLastWeek?.length} za posledných 7 dní`}</Typography>
      </CardContent>
    </Card>
  );
};
